<template>
  <div class = "paginaDedicata">
    <NormalHeader :data="header"/>
    <img :src="logo" class = "imagine">
    <h1 class = "title">{{$t(title)}}</h1>
    <p v-html="$t(text1)" class = "text"></p>
    <h2 class = "subtitle">{{$t(subtitle)}}</h2>
    <p v-html="$t(text2)" class = "text"></p>
  </div> 
</template>

<script>
import NormalHeader from '@/components/global-components/NormalHeader'
export default {
  components:{
    NormalHeader
  },
  data() {
    return {
      header: {
        transparent: false
      },
      logo : "https://i.imgur.com/4kCqxva.png",
      title: "dedicate.uipath.title",
      subtitle: "dedicate.uipath.subtitle",
      text1: "dedicate.uipath.text1",
      text2: "dedicate.uipath.text2",
      header: {
        transparent: false
      }
    }
  }
} 
</script>

<style scoped lang="scss">
.imagine {
  margin-top: 5%!important;
  margin-bottom: 6%!important;
  padding-top: 0px;
  height: 25vh;
  display: block;
  margin: auto;
}

.title {
  margin-bottom: 4%;
  font-size: 35px!important;
}

.text {
  text-align: center;
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 5%;
  font-size: 20px!important;
}

.subtitle {
   font-size: 30px!important;
}

.paginaDedicata {
  color: $primary-color !important;
}

@media screen and (max-width: 600px) {
  .imagine {
    height: 20vh;
  }
}

</style>